import React, { useEffect, useState } from 'react';
import Switch from 'react-switch';
import PropTypes from 'prop-types';

import { AvForm, AvField } from 'availity-reactstrap-validation';
import { AddButton, Buttons, UpdateButton, CancelButton } from '../../components/Common/iComponents/iPopUp/IpopUp';

import { Card, CardBody, CardText, CardTitle, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';

import classnames from 'classnames';
import { IInput } from '../../components/Common/iComponents/iInput/iInput';

const FormMilestone = ({ classNameStick, selectedRow, OperationName, onCreate, onUpdate, onDelete, onCancel }: any) => {
    const hidden = 'hidden';
    const visibleInTable = 'visibleInTable';
    const visibleInModalHeader = 'visibleInModalHeader';
    const visibleInModalBody = 'visibleInModalBody';
    const visibleInModalFooter = 'visibleInModalFooter';
    const visibleInModalTotal = 'visibleInModalTotal';
    const isMilestone = 'isMilestone';
    const showInFilters = 'showInFilters';

    const [form, setForm] = useState({
        [hidden]: false,
        [visibleInTable]: false,
        [visibleInModalHeader]: false,
        [visibleInModalBody]: false,
        [visibleInModalFooter]: false,
        [visibleInModalTotal]: false,
        [isMilestone]: false,
        [showInFilters]: false,
    });

    const [customActiveTab, setcustomActiveTab] = useState(1);
    const [customActiveTabCommodity, setcustomActiveTabCommodity] = useState(1);
    const [currentRelatedObject,setCurrentRelatedObject] = useState("");
    const [customActiveTabArray, setcustomActiveTabArray] = useState<any>();
    const [customActiveTabArrayRelatedObject, setcustomActiveTabArrayRelatedObject] = useState<any>();
    const [filter,setFilter] = useState("");

    const relatedObjList = ["Sales Order","Purchase Order","Cargo Release","Warehouse Receipt","Shipments","Pickup Orders", "Bookings", "Quotation"]

    const checkFieldExistence = (prefix: string, selectedRow: any[]): boolean => {
        return selectedRow.filter((item: any) => item?.dataField?.startsWith(prefix)).length >= 1;
    };

    useEffect(() => {
        if (selectedRow) {
            let CUSTOM_FIELDExist = false;
            let CFExist = false;

            let RelatedObjects = false;

            if (OperationName === 'Commodity List') {
                RelatedObjects = true;
                CUSTOM_FIELDExist = checkFieldExistence('CUSTOM_FIELD_', selectedRow);

                CFExist = checkFieldExistence('CF', selectedRow);
            } else {
                CFExist = checkFieldExistence('CF', selectedRow);
            }
            const newArray = [{ label: OperationName, number: 1 }];
            if (CFExist) newArray.push({ label: 'Custom Fields', number: 2 });
            if (CUSTOM_FIELDExist) newArray.push({ label: "Comodity CF's", number: 3 });
            if(RelatedObjects) newArray.push({ label: 'Related Objects', number: 12 });
            setcustomActiveTabArray(newArray);
            setForm(selectedRow);
        }
    }, [selectedRow]);

    const toggleCustom = (tab: any) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const toggleCustomRelatedObj = (tab: any) => {
        if (customActiveTabCommodity !== tab) {
            setcustomActiveTabCommodity(tab);
        }
    };

    function useWindowSize(): any {
        const [windowSize, setWindowSize] = useState<any>({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            function handleResize() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            window.addEventListener('resize', handleResize);
            handleResize();
            return () => window.removeEventListener('resize', handleResize);
        }, []);
        return windowSize;
    }
    const size = useWindowSize();

    const renderButtons = () => (
        <Buttons
            className="buttonsMilestones"
            style={{
                justifyItems: 'end',
                gridTemplateColumns: `repeat(9, 1fr)`,
                gridAutoRows: 'minmax(11%, 75px)',
                gridGap: '3%',
                padding: '0px',
                paddingTop: '4px',
                paddingRight: '90px',
                position: 'fixed',
                bottom: '64px',
                width: '83%',
                backgroundColor: 'transparent',
            }}
        >
            {selectedRow ? (
                <>
                {customActiveTab != 12 || customActiveTabArrayRelatedObject ? (
                    <UpdateButton className="btn button" onClick={() => onUpdate(form,(customActiveTab == 12 && customActiveTabArrayRelatedObject))}>
                    Update
                </UpdateButton>
                ):null}
                    
                    <CancelButton className="btn button" onClick={() => onCancelMilestones()}>
                        Cancel
                    </CancelButton>
                </>
            ) : (
                <AddButton type="submit" className="btn" onClick={() => onCreate(form)}>
                    Add
                </AddButton>
            )}
        </Buttons>
    );


    const onCancelMilestones = ()=>{
        if(customActiveTab == 12 && customActiveTabArrayRelatedObject){
            setcustomActiveTabArrayRelatedObject(null)
            setcustomActiveTabCommodity(1)
            setCurrentRelatedObject("")
        }else{
            onCancel()
        }
    }

    const renderHeaderTable = () => (
        <Row className={classNameStick}>
            <Col xl={3} md={2} sm="2" className="bg-primary text-white columnsTitleMilestone text-center">
                <label className="switch-label">Text for field</label>
            </Col>
            <Col xl={1} md={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <label className="switch-label">Order</label>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">Hidden</label>
                </div>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">In Table</label>
                </div>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center ">
                <div>
                    <label className="switch-label">In Modal Header</label>
                </div>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">In Modal Body</label>
                </div>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">Title</label>
                </div>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">In Modal Total</label>
                </div>
            </Col>

            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">is Milestone</label>
                </div>
            </Col>
            <Col xl={1} sm="1" className="bg-primary text-white columnsTitleMilestone text-center">
                <div>
                    <label className="switch-label">Filter</label>
                </div>
            </Col>
        </Row>
    );

    useEffect(()=>{
        if(currentRelatedObject){
            let CRFCFExist = false;
            let CRExist = false;

            let POCFExist = false;
            let POExist = false;

            let WRCFExist = false;
            let WRExist = false;

            let SOCFExist = false;
            let SOExist = false;

            let SHCFExist = false;
            let SHExist = false;

            let IPKCFExist = false;
            let IPKExist = false;

            let BKCFExist = false;
            let BKExist = false;

            let QTCFExist = false;
            let QTKExist = false;

            switch(currentRelatedObject){
                case "Sales Order":
                    setcustomActiveTabCommodity(4)
                    SOExist = checkFieldExistence('SO', selectedRow);
                    SOCFExist = checkFieldExistence('SOCF', selectedRow);
                break;

                case "Purchase Order":
                    setcustomActiveTabCommodity(6)
                    POCFExist = checkFieldExistence('POCF', selectedRow);
                    POExist = checkFieldExistence('PO', selectedRow);
                break;

                case "Cargo Release":
                    setcustomActiveTabCommodity(8)
                    CRFCFExist = checkFieldExistence('CRCF', selectedRow);
                    CRExist = checkFieldExistence('CR', selectedRow);

                break;
                case "Warehouse Receipt":
                    setcustomActiveTabCommodity(10)
                    WRCFExist = checkFieldExistence('WRCF', selectedRow);
                    WRExist = checkFieldExistence('WR', selectedRow);
                break;
                case "Shipments":
                    setcustomActiveTabCommodity(12)
                    SHCFExist = checkFieldExistence('SHCF', selectedRow);
                    SHExist = checkFieldExistence('SH', selectedRow);

                break;
                case "Pickup Orders":
                    setcustomActiveTabCommodity(14)
                    IPKCFExist = checkFieldExistence('IPKCF', selectedRow);
                    IPKExist = checkFieldExistence('IPK', selectedRow);
                break;
                case "Booking":
                    setcustomActiveTabCommodity(16)
                    BKCFExist = checkFieldExistence('BKCF', selectedRow);
                    BKExist = checkFieldExistence('BK', selectedRow);
                break;
                case "Quotation":
                    setcustomActiveTabCommodity(18)
                    QTCFExist = checkFieldExistence('QTCF', selectedRow);
                    QTKExist = checkFieldExistence('QT', selectedRow);
                break;
            }
            const newArray = [];
            if (SOExist) newArray.push({ label: 'Sales Order', number: 4 });
            if (SOCFExist) newArray.push({ label: "Custom Fields", number: 5 });
            if (POExist) newArray.push({ label: 'Purchase Order', number: 6 });
            if (POCFExist) newArray.push({ label: "Custom Fields", number: 7 });
            if (CRExist) newArray.push({ label: 'Cargo Release', number: 8 });
            if (CRFCFExist) newArray.push({ label: "Custom Fields", number: 9 });
            if (WRExist) newArray.push({ label: 'WareHouse Receipt', number: 10 });
            if (WRCFExist) newArray.push({ label: "Custom Fields", number: 11 });
            if (SHExist) newArray.push({ label: 'Shipments', number: 12 });
            if (SHCFExist) newArray.push({ label: "Custom Fields", number: 13 });
            if (BKExist) newArray.push({ label: 'Booking', number: 16 });
            if (BKCFExist) newArray.push({ label: "Custom Fields", number: 17 });
            if (QTKExist) newArray.push({ label: 'Quotation', number: 18 });
            if (QTCFExist) newArray.push({ label: "Custom Fields", number: 19 });
            setcustomActiveTabArrayRelatedObject(newArray);
        }

    },[currentRelatedObject])

    const handleFilter = (change:any,namekey:any)=>{
        setFilter(change.target.value)
    }


    const renderRelatedObj = ()=>{
        return(
            <div className='CardsRelatedObjCommoditys'>
                {relatedObjList.map((operation,index)=>{
                    return(
                        <Card
                        onClick={()=>{setCurrentRelatedObject(operation)}}
                        key={`${operation}-${index}`}
                        className="my-2 bg-primary text-white"
                        inverse
                        style={{
                        width: '18rem'
                        }}
                    >
                            <CardBody>
                                <CardTitle className='text-white' tag="h5">
                                    {operation}
                                </CardTitle>
                                <CardText>
                                {operation} custom fields and attributes
                                </CardText>
                            </CardBody>
                    </Card>
                    )
                })}
            </div>
        )
    }

    return (
        <>
            <Nav tabs className="nav-tabs-custom nav-justified pb-3">
                {customActiveTabArray?.map((item: any) => {
                    return (
                        <NavItem key={item.number}>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({
                                    active: customActiveTab === item.number,
                                })}
                                onClick={() => {
                                    toggleCustom(item.number);
                                }}
                            >
                                <span className="d-block d-sm-none">
                                    <i className="fas fa-home"></i>
                                </span>
                                <span className="d-none d-sm-block">{item.label}</span>
                            </NavLink>
                        </NavItem>
                    );
                })}
            </Nav>

            {customActiveTabArrayRelatedObject &&  customActiveTab == 12? (
                <Nav tabs className="nav-tabs-custom nav-justified pb-3 border-t">
                {customActiveTabArrayRelatedObject?.map((item: any) => {
                    return (
                        <NavItem key={item.number}>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({
                                    active: customActiveTabCommodity === item.number,
                                })}
                                onClick={() => {
                                    toggleCustomRelatedObj(item.number);
                                }}
                            >
                                <span className="d-block d-sm-none">
                                    <i className="fas fa-home"></i>
                                </span>
                                <span className="d-none d-sm-block">{item.label}</span>
                            </NavLink>
                        </NavItem>
                    );
                })}
            </Nav>
            ):null}

            {customActiveTab != 12 || customActiveTabArrayRelatedObject ? (<div className='fileFilterOperationsConfig'>
                <IInput
                    value={filter}
                    style={{width:"400px"}}
                    onChangeHandler={handleFilter}
                    type='text'
                        title="Filter"
                     />
            </div>):null}

            { customActiveTab != 12 || customActiveTabArrayRelatedObject ? renderHeaderTable():renderRelatedObj()}

            <AvForm
                className="custom-form mt-0"
                style={{
                    gridAutoRows: 'minmax(5%, 15px)',
                    gridGap: '45px',
                    padding: '20px 20px 25px 6px',
                    paddingLeft: '10px',
                    display: 'grid',
                    minHeight: `${size.height - 500}px`,
                    maxHeight: `${size.height - 380}px`,
                }}
            >
                {selectedRow
                    ?.filter((itemFilter: any) => {
                        const prefixes = ['CF', 'CUSTOM_FIELD_', 'SO', 'SOCF', 'PO', 'POCF', 'CR', 'CRCF', 'WR', 'WRCF',"SH","SHCF","IPK","IPKCF","BK","BKCF","QT","QTCF"    ];
                        const filterLower = filter.toLowerCase(); // Convertimos filter a minúsculas una vez
                        const textLower = itemFilter.text.toLowerCase(); // Convertimos itemFilter.text a minúsculas una vez
                        const dataField = itemFilter.dataField || '';
                    
                        if (textLower.includes(filterLower) || filter === "") {
                          let valid = false;
                          switch (customActiveTab) {
                            case 1:
                              valid = !prefixes.some((prefix) => dataField.startsWith(prefix));
                              break;
                            case 2:
                              valid = dataField.startsWith('CF');
                              break;
                            case 3:
                              valid = dataField.includes('CUSTOM_FIELD_');
                              break;
                            case 12:
                              switch (customActiveTabCommodity) {
                                case 4:
                                  valid = dataField.startsWith('SO') && !dataField.startsWith('SOCF');
                                  break;
                                case 5:
                                  valid = dataField.startsWith('SOCF');
                                  break;
                                case 6:
                                  valid = dataField.startsWith('PO') && !dataField.startsWith('POCF');
                                  break;
                                case 7:
                                  valid = dataField.startsWith('POCF');
                                  break;
                                case 8:
                                  valid = dataField.startsWith('CR') && !dataField.startsWith('CRCF');
                                  break;
                                case 9:
                                  valid = dataField.startsWith('CRCF');
                                  break;
                                case 10:
                                  valid = dataField.startsWith('WR') && !dataField.startsWith('WRCF');
                                  break;
                                case 11:
                                  valid = dataField.startsWith('WRCF');
                                  break;

                                  case 12:
                                  valid = dataField.startsWith('SH') && !dataField.startsWith('SHCF');
                                  break;
                                case 13:
                                  valid = dataField.startsWith('SHCF');
                                  break;
                                case 14:
                                  valid = dataField.startsWith('IPK') && !dataField.startsWith('IPKCF');
                                  break;
                                case 15:
                                  valid = dataField.startsWith('IPK');
                                  break;
                                case 16:
                                  valid = dataField.startsWith('Bk');
                                  break;
                                case 17:
                                  valid = dataField.startsWith('BKCF');
                                  break;
                                case 18:
                                  valid = dataField.startsWith('QT');
                                  break;
                                case 19:
                                  valid = dataField.startsWith('QTCF');
                                  break;
                                  
                                default:
                                  valid = false;
                              }
                              break;
                            default:
                              valid = false;
                          }
                          return valid;
                        } else {
                          return false;
                        }
                      })
                    .map((item: any, key: any) => {
                        return (
                            <>
                                <Row className="align-items-center">
                                    <Row>
                                        <Col sm={3}>
                                            <div className="ps-1">{item.dataField}</div>
                                        </Col>
                                    </Row>
                                    <Col xl={3} md={2} sm="2">
                                        <Row>
                                            <Col>
                                                <AvField
                                                    id={item.dataField + 'text' + key}
                                                    name={item.dataField}
                                                    value={item.text || ''}
                                                    className="form-control section-input"
                                                    placeholder={item.dataField}
                                                    defaultValue={item.dataField !== '' ? item.dataField : item.text}
                                                    type="text"
                                                    onChange={(e: any) => {
                                                        item.text = e.target.value;
                                                        const newForm = { ...form };
                                                        setForm(newForm);
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xl={1} md={1} sm="1" className="columnsTitleMilestoneData text-center ">
                                        <AvField
                                            id={item.dataField + 'order' + key}
                                            name="order"
                                            value={item.order || ''}
                                            className="form-control section-input align-self-center"
                                            placeholder={`${item.dataField} order`}
                                            type={'number'}
                                            onChange={(e: any) => {
                                                item.order = parseInt(e.target.value);
                                                const newForm = { ...form };
                                                setForm(newForm);
                                            }}
                                        />
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <Switch
                                            id={item.dataField + 'hidden' + key}
                                            name={item.hidden}
                                            className="switch"
                                            checked={item[hidden]}
                                            onChange={() => {
                                                item.hidden = !item.hidden;
                                                item.visibleInTable = false;
                                                item.visibleInModalHeader = false;
                                                item.visibleInModalBody = false;
                                                item.visibleInModalTotal = false;
                                                item.isMilestone = false;
                                                item.visibleInModalFooter = false;
                                                item.showInFilters = false;
                                                const newForm = { ...form };
                                                setForm(newForm);
                                            }}
                                        />
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <Switch
                                            id={item.dataField + 'visibleInTable' + key}
                                            name={item.hidden}
                                            className="switch "
                                            checked={item[visibleInTable]}
                                            onChange={() => {
                                                item.hidden = false;
                                                item.visibleInTable = !item.visibleInTable;
                                                const newForm = { ...form };
                                                setForm(newForm);
                                            }}
                                        />
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <Switch
                                            id={item.dataField + 'visibleInModalHeader' + key}
                                            name={item.visibleInModalHeader}
                                            className="switch"
                                            checked={item[visibleInModalHeader]}
                                            onChange={() => {
                                                item.hidden = false;
                                                item.visibleInModalHeader = !item.visibleInModalHeader;
                                                const newForm = { ...form };
                                                setForm(newForm);
                                            }}
                                        />
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <div>
                                            <div>
                                                <label>
                                                    <Switch
                                                        id={item.dataField + 'visibleInModalBody' + key}
                                                        name={item.visibleInModalBody}
                                                        className="switch"
                                                        checked={item[visibleInModalBody]}
                                                        onChange={() => {
                                                            item.hidden = false;
                                                            item.visibleInModalBody = !item.visibleInModalBody;
                                                            const newForm = { ...form };
                                                            setForm(newForm);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <div>
                                            <div>
                                                <label>
                                                    <Switch
                                                        id={item.dataField + 'hidden' + key}
                                                        name={item.visibleInModalFooter}
                                                        className="switch"
                                                        checked={item[visibleInModalFooter]}
                                                        onChange={() => {
                                                            item.hidden = false;
                                                            item.visibleInModalFooter = !item.visibleInModalFooter;
                                                            const newForm = { ...form };
                                                            setForm(newForm);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <div>
                                            <div>
                                                <label>
                                                    <Switch
                                                        id={item.dataField + 'hidden' + key}
                                                        name={item.visibleInModalTotal}
                                                        className="switch"
                                                        checked={item[visibleInModalTotal]}
                                                        onChange={() => {
                                                            item.hidden = false;
                                                            item.visibleInModalTotal = !item.visibleInModalTotal;
                                                            const newForm = { ...form };
                                                            setForm(newForm);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <div>
                                            <div>
                                                <label>
                                                    <Switch
                                                        id={item.dataField + 'hidden' + key}
                                                        name={item.isMilestone}
                                                        className="switch"
                                                        checked={item[isMilestone]}
                                                        onChange={() => {
                                                            item.hidden = false;
                                                            item.isMilestone = !item.isMilestone;
                                                            const newForm = { ...form };
                                                            setForm(newForm);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xl={1} sm="1" className="columnsTitleMilestoneData text-center">
                                        <div>
                                            <div>
                                                <label>
                                                    <Switch
                                                        id={item.dataField + 'hidden' + key}
                                                        name={item.isMilestone}
                                                        className="switch"
                                                        checked={item[showInFilters]}
                                                        onChange={() => {
                                                            item.hidden = false;
                                                            item.showInFilters = !item.showInFilters;
                                                            const newForm = { ...form };
                                                            setForm(newForm);
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        );
                    })}
            </AvForm>
            {renderButtons()}
        </>
    );
};

FormMilestone.propTypes = {
    classNameStick: PropTypes.string,
    selectedRow: PropTypes.object,
    OperationName: PropTypes.string,
    onCreate: PropTypes.func,
    onCancel: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
};

export default FormMilestone;
